import Component from '../core/Component'

export default class OverflowIndicator extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            ...options,
        })

        this.ref = {
            targetEl: null,
            indicator: null,
        }
    }

    prepare() {
        this.ref.targetEl = document.querySelector(this.options.query)
        if (this.ref.targetEl) {
            this.ref.targetEl.addEventListener('scroll', this.handleTargetScroll)
        }
        setTimeout(() => {
            this.update()
        }, 0);
    }

    handleTargetScroll = () => {
        this.update()
    }

    update() {
        const remaining = this.ref.targetEl.scrollLeft / (this.ref.targetEl.scrollWidth - this.ref.targetEl.offsetWidth)
        this.ref.indicator.style.width = `${Math.min(1, Math.max(.15, remaining)) * 100}%`
    }
}